var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classObject},_vm._l((_vm.listData),function(item,index){return _c('div',{key:`${item.name}-${index}`},[_c('PublicEcharts',{attrs:{"id":`${_vm.assetId}-${index}-${item.name}`,"chartsData":item,"options":_vm.dealLiquidfillData(item),"usePropsOptions":""}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }